<script setup lang="ts">
import { bemBuilder, debounce } from "@chatfood/core-utils";
import { ref, watch } from "vue";
import { AtomInput, SatFormControl } from "@chatfood/design-system";
import type { BasketPaxProps } from "./props";
import { useLocale } from "~/composables/use-locale";
import { useBasketStore } from "~/stores/basket";

const props = withDefaults(defineProps<BasketPaxProps>(), {
  autoSave: false,
});

const emits = defineEmits<{ update: [value?: number] }>();

const css = bemBuilder("basket-pax");

const { t } = useLocale();

const basketStore = useBasketStore();

const pax = ref(basketStore.pax?.toString() || "");

const debouncedSetMeta = debounce(() => {
  basketStore.setMeta({ pax: pax.value ? Number(pax.value) : null });
}, 500);

watch(
  () => pax.value,
  (newValue, oldValue) => {
    if (newValue === oldValue) return;

    const numberValue = newValue ? Number(newValue) : undefined;
    emits("update", numberValue);

    if (!props.autoSave) return;

    debouncedSetMeta();
  },
);
</script>

<template>
  <div :class="css('')">
    <SatFormControl :label="t('components.basket_pax.label')">
      <AtomInput :value="pax" type="number" @keyup="(value) => (pax = value)" />
    </SatFormControl>
  </div>
</template>

<style lang="scss" scoped>
.basket-pax {
  position: relative;
}
</style>
